import {
  Avatar,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Skeleton,
} from '@mui/material' // Import MUI components

const LoadingDocuments = () => (
  <Grid container justifyContent="center" sx={{ p: 2 }}>
    <Grid item md={4} xs={12}>
      <List>
        {[...Array(3)].map((value: unknown, index: number) => (
          <ListItem key={index}>
            <ListItemAvatar>
              <Avatar>
                <Skeleton height={40} variant="circular" width={40} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={<Skeleton variant="text" />}
              secondary={<Skeleton variant="text" />}
            />
          </ListItem>
        ))}
      </List>
    </Grid>
  </Grid>
)
export default LoadingDocuments
